export default "__VITE_ASSET__B1OwTFp4__"